var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app-bar', {
    style: {
      backgroundColor: _vm.navColor
    },
    attrs: {
      "div": "navbar",
      "app": "",
      "dark": "",
      "flat": "",
      "dense": "",
      "height": 140
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": require("@/assets/explorer_logo_".concat(_vm.logoColor, ".png"))
    }
  }), _c('h1', [_c('span', {
    staticClass: "hide"
  }, [_vm._v("Avalanche Explorer")])])])], 1), _c('v-spacer', {
    staticClass: "spacer_mid"
  }), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "routes"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _c('router-link', {
    attrs: {
      "to": "/subnets"
    }
  }, [_vm._v("Subnets")]), _c('router-link', {
    attrs: {
      "to": "/validators"
    }
  }, [_vm._v("Validators")]), _c('a', {
    attrs: {
      "href": _vm.tokensURL
    }
  }, [_vm._v("Tokens")]), _c('router-link', {
    attrs: {
      "to": "/blockchains"
    }
  }, [_vm._v("Blockchains")]), _vm.isMainnet ? _c('a', {
    attrs: {
      "href": _vm.statsURL
    }
  }, [_vm._v("Stats")]) : _vm._e(), _c('a', {
    attrs: {
      "href": _vm.cChainURL
    }
  }, [_vm._v("C-Chain")]), _c('a', {
    attrs: {
      "href": _vm.statusPageURL
    }
  }, [_vm._v("Status")]), _c('router-link', {
    attrs: {
      "to": "/resources"
    }
  }, [_vm._v("Resources")])], 1)]), _c('v-spacer', {
    staticClass: "spacer_mid"
  }), _c('NetworkMenu')], 1), _c('div', {
    staticClass: "bottom"
  }, [_vm.pricesLoaded ? _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price_pair"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("AVAX")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.priceUSD))])])]) : _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  }), _c('div', [_c('SearchBar', {
    staticClass: "search_bar",
    attrs: {
      "placeholder": "Search by Address / TxId / Asset"
    },
    on: {
      "search": _vm.onsearch
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }